module.exports = __webpack_public_path__ + "img/icon2.cfe8be1d.png";